import { PROJECTS_BILLING_SETTINGS } from '~/modules/billing-invoicing/common/hooks';

export const useFetchProjectsBillingSettings = ({ apolloClient }) => {
  return {
    fetchProjectsBillingSettings: async projectIds => {
      const { data } = await apolloClient.query({
        query: PROJECTS_BILLING_SETTINGS,
        variables: {
          page: 1,
          pageSize: projectIds.length,
          projectFilter: { projects: projectIds }
        },
        fetchPolicy: 'network-only'
      });

      return (data?.projects || []).reduce(
        (acc, { id, projectBillSettings }) => ({
          ...acc,
          [id]: projectBillSettings
        }),
        {}
      );
    }
  };
};
